import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';
import { Project, ProjectDetails } from '@Types';

export const useCreateProjectDetails = () => {
  const [fetch, response] = useRequest<Project>();

  const createProjectDetails = useCallback(
    (data: ProjectDetails & { matchmaking_apply_fund_non_profit_link_id?: number }) => {
      const { matchmaking_apply_fund_non_profit_link_id, ...details } = data;

      // Only include the field if it has a valid value
      const requestData: any = {
        details,
        delivery_plan: null,
        written_pitch: null,
        video_pitch: null,
      };

      if (matchmaking_apply_fund_non_profit_link_id !== undefined) {
        requestData.matchmaking_apply_fund_non_profit_link_id =
          matchmaking_apply_fund_non_profit_link_id;
      }

      return fetch(API.paths.projects, 'post', {
        data: requestData,
      });
    },
    [fetch],
  );

  return [createProjectDetails, response] as const;
};
